<template>
    <div>
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" border
        :load="load"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}" 
        row-key="id"
        :cell-class-name="tableCellClassName">
        <el-table-column prop="channels" label="Chanels"></el-table-column>
        <el-table-column prop="reason" label="Reason"></el-table-column>
        <el-table-column prop="totalOrder" label="Total Order#"></el-table-column>
        <el-table-column prop="failedOrder" label="Failed Order#"></el-table-column>
        <el-table-column prop="failure" label="Failure%" ></el-table-column>
      </el-table>
    </div>
</template>
<script>
import { getChannelFailures} from "../../api/bookingData.js";
export default {
data() {
  return {
    tableData: [],
  }
},
mounted() {
  this.getChannelFailuresData()
},
methods: {
  load(tree, treeNode, resolve) {
    resolve([
      {id: tree.id*10 + 1,chanels: tree.chanels,reason: '第三方预订失败',totalOrder: '',failedOrder: '',failure: ''}, 
      {id: tree.id*10 + 2,chanels: tree.chanels,reason: '公付失败',totalOrder: '',failedOrder: '',failure: ''},
      {id: tree.id*10 + 3,chanels: tree.chanels,reason: '参数错误',totalOrder: '1248',failedOrder: '282',failure: '28%'}, 
      {id: tree.id*10 + 4,chanels: tree.chanels,reason: '价格变化',totalOrder: '580',failedOrder: '250',failure: '42%'}, 
      {id: tree.id*10 + 5,chanels: tree.chanels,reason: '售罄/满房',totalOrder: '',failedOrder: '',failure: ''}, 
      {id: tree.id*10 + 6,chanels: tree.chanels,reason: '重复预订',totalOrder: '',failedOrder: '',failure: ''}, 
      {id: tree.id*10 + 7,chanels: tree.chanels,reason: '未完成担保/支付',totalOrder: '',failedOrder: '',failure: ''}, 
      {id: tree.id*10 + 8,chanels: tree.chanels,reason: '后审未通过',totalOrder: '',failedOrder: '',failure: ''}, 
    ])
  },
  tableCellClassName({row, column, rowIndex, columnIndex}){
    var failure = parseFloat(row.failure);
    switch(true){
      case (failure <= 5 && columnIndex >=2):
        return 'failure5-row';
      case (failure > 5 && failure <= 10 && columnIndex >=2):
        return 'failure10-row';
      case (failure > 10 && failure <= 20 && columnIndex >=2):
        return 'failure20-row';
      case (failure > 20 && failure <= 30 && columnIndex >=2):
        return 'failure30-row';
      case (failure > 30 && columnIndex >=2):
        return 'failure100-row';
    }  
  },
  getChannelFailuresData(){
    let orderParam = {
      params: {
        hoursAgo: 24,
      },
    };
    getChannelFailures(orderParam)
    .then((res) => {
      if(res.code == 200){
        res.data.tableData.forEach(parent => {
          if (parent.children && Array.isArray(parent.children)) {
            parent.children.forEach(child => {
              child.id = parent.id * 10 + child.id;
            });
          }
        });
        this.tableData = res.data.tableData;
      }
    });
  }
},
}
</script>
<style>
.el-table .failure5-row {
  background-color: #e2efda;
}
.el-table .failure10-row {
  background-color: #fbfb99;
}
.el-table .failure20-row {
  background-color: #ffff00;
}
.el-table .failure30-row {
  background-color: #ffc000;
}
.el-table .failure100-row {
  background-color: #ff0000;
}
</style>